import React from 'react';
import classnames from 'classnames';
import template from 'lodash/template';
import { PAYMENT_TYPES } from '../../../constants';

import { maxCharactersTemplate } from '../../gluValidation/utils';
import Input from '../components/WireInput';
import { lt } from '../../../utils/validations/gluValidations';
import { specialChars } from '../utils';

export const fieldTypes = {
  BC: 'bank-code-<%=line%>',
  PD: 'line<%=line%>',
  BTB: 'line<%=line%>'
};

/**
 * Build dynamically input lines for PD and BTB.
 * @param {object} props
 * @param {object} locale
 * @param {object} preferences
 * @param {object} fields
 * @param {string} paymentType
 * @param {object} classes,
 * @param {func} onChange
 */
export const buildSectionLines =
  ({ classes, formState, locale, onChange, paymentType, preferences }) =>
  (type) => {
    const perRow = 2;
    const isDomestic = paymentType === PAYMENT_TYPES.WIRE.DOMESTIC;
    const {
      bankTobankAllowedChars,
      bankTobankAllowedLines,
      bankTobankIntAllowedChars,
      bankTobankIntAllowedLines,
      paymentDetailsAllowedChars,
      paymentDetailsAllowedLines,
      paymentDetailsIntAllowedChars,
      paymentDetailsIntAllowedLines
    } = preferences;

    const lines = {
      PD: isDomestic ? paymentDetailsAllowedLines : paymentDetailsIntAllowedLines,
      BTB: isDomestic ? bankTobankAllowedLines : bankTobankIntAllowedLines
    };

    const sizing = {
      PD: isDomestic ? paymentDetailsAllowedChars : paymentDetailsIntAllowedChars,
      BTB: isDomestic ? bankTobankAllowedChars : bankTobankIntAllowedChars
    };

    const rows = [...Array(Math.ceil(lines[type] / perRow)).keys()].map((x) => x + 1);

    const model = {
      PD: 'paymentDetails',
      BTB: 'bankToBankDetails'
    };

    const preloaded = formState[model[type]];

    return rows.map((num) => {
      const allowed = num * perRow <= lines[type] ? perRow : lines[type] % perRow;
      const elems = [...Array(allowed).keys()].map((x) => x + 1);
      const elemId = `${type}-${num}`;

      return (
        <div key={elemId} className={classnames('col-xs-12', classes.oriInfoRow)}>
          {elems.map((f) => {
            const line = num * perRow - perRow + f;
            const id = `${type.toLowerCase()}-${template(fieldTypes[type])({ line })}`;
            return (
              <Input
                key={id}
                debounceInput
                className="col-xs-6"
                optional
                label={template(locale['paymentAdditionalDetails.line'])({ line })}
                id={id}
                name={id}
                maxLength={sizing[type]}
                defaultValue={preloaded && preloaded[`line${line}`]}
                onChange={onChange}
                validators={[
                  lt({
                    maxLength: sizing[type],
                    msg: maxCharactersTemplate(locale, sizing[type])
                  }),
                  specialChars({
                    locale,
                    paymentType: formState.paymentTypeStr,
                    prefs: preferences
                  })
                ]}
              />
            );
          })}
        </div>
      );
    });
  };
